import { NgModule } from '@angular/core';
import { LabelPipe, LabelExistsPipe } from './label.pipe';
import { LabelsService } from './labels.service';

/**
 * Labels Module
 * 
 * Import this module to use labels in your templates:
 * ```typescript
 * @NgModule({
 *   imports: [LabelsModule]
 * })
 * export class YourModule { }
 * ```
 * 
 * Or import in SharedModule for app-wide availability.
 */
@NgModule({
  declarations: [
    LabelPipe,
    LabelExistsPipe
  ],
  exports: [
    LabelPipe,
    LabelExistsPipe
  ],
  providers: [
    LabelsService
  ]
})
export class LabelsModule { }
